// For more information regarding different sizes, see https://uth.ingka.com/articles/image-optimization-on-ikeacom/

const appendIkeaImageSizeParam = (url: string, sizeParam: string): string => {
  if (!url) return "";

  try {
    const urlObj = new URL(url);

    const isIkeaHostname = /(^|\.)ikea\./i.test(urlObj.hostname);
    if (!isIkeaHostname || !urlObj.pathname.toLowerCase().endsWith(".jpg")) {
      return url;
    }

    urlObj.searchParams.set("f", sizeParam);
    return urlObj.toString();
  } catch {
    return url;
  }
};

// Appends "?f=xu" to IKEA product image URLs to receive an 80x80 pixel image.
export const getSmallThumbnailImageUrl = (url: string): string =>
  appendIkeaImageSizeParam(url, "xu");

// Appends "?f=u" to IKEA product image URLs to receive a 160x160 pixel image.
export const getTaskHeaderImageUrl = (url: string): string =>
  appendIkeaImageSizeParam(url, "u");
